import React from 'react';
import { Controller } from 'react-hook-form';
import { CombinedCertificationsInput } from './CombinedCertificationsInput';

const transformToOptions = (items) =>
  Array.isArray(items)
    ? items.map((item) => ({
        value: item.id.toString(),
        label: item.name,
        abbreviation: item.abbreviation || item.short_name,
        category: item.category || item.category_name || 'All Certifications',
      }))
    : [];

export function CertificationsSection({ control, masterData, watch }) {
  const certificationOptions = React.useMemo(
    () => transformToOptions(masterData?.certifications),
    [masterData?.certifications]
  );

  const currentCertifications = watch?.('certifications') || [];

  const defaultCertifications = React.useMemo(
    () => (Array.isArray(currentCertifications) ? currentCertifications : []),
    [currentCertifications]
  );

  return (
    <div>
      <Controller
        name="certifications"
        control={control}
        defaultValue={defaultCertifications}
        render={({ field: { onChange, value: certificationsValue = [] } }) => (
          <CombinedCertificationsInput
            options={certificationOptions}
            value={{ certifications: certificationsValue }}
            onChange={(combinedValue) => onChange(combinedValue.certifications)}
            placeholder="Search certifications..."
            className="text-xs"
          />
        )}
      />
    </div>
  );
}
